import script from "./RevenueQFZP.vue?vue&type=script&setup=true&lang=js"
export * from "./RevenueQFZP.vue?vue&type=script&setup=true&lang=js"

import "./RevenueQFZP.vue?vue&type=style&index=0&id=5d52baa2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d52baa2"]])

export default __exports__